import { trips } from './TripsData';


export const profiles = [
    {
        id: 1,
        title: "מאיה גלר",
        image: "/images/avatar.png",
        coverImage: "/images/maya-cover1.jpg",
        date_of_birth: "1998-06-20",
        location: "ירושלים",
        interests: "טיולים, טבע, צילום, מוזיקה",
        favorite_trip_locations: ["גליל עליון", "הרי ירושלים"],
        favorite_trip_styles: ["טיול עונתי / פריחות", "פיקניק", "טבע ונוף"],
        about: "אני סטודנטית שנה ב' לביולוגיה וקוגניציה באוניברסיטה העברית בירושלים. אוהבת לטייל בטבע, להכיר אנשים חדשים ולגלות פינות קסומות בארץ. במקור מחיפה.\n" +
            "אוהבת לטייל עם אנשים זורמים שאוהבים טבע, צחוק ושיחות טובות. תמיד שמחה למצוא פרטנרים לטיול יום ספונטני או לסופ\"ש רגוע בטבע 🌸️.",
        looking_for: "מחפשת שלושה שותפים זורמים לטיול מאתגר ברמת קושי קשה",
        favoriteTrips: [trips[0], trips[1]]
    },
    {
        id: 2,
        title: "רועי לוי",
        image: "/images/Roy_Levi.png",
        coverImage: "/images/maya-cover1.jpg",
        age: "29",
        location: "תל אביב",
        interests: "גלישת גלים, בישול, מוזיקת אינדי, טיולים",
        favorite_trip_locations: ["רמת הגול", "חוף פלמחים"],
        favorite_trip_styles: ["טיולי אוכל מקומי", "טרקים אתגריים", "קמפינג על הים", "טיולים רגועים"],
        about: "אני עובד כמעצב גרפי ומנצל כל סופ\"ש לצאת לטבע או לגלוש בים. אוהב לגלות חופים חדשים ולטייל עם אנשים קלילים שאוהבים אוכל טוב ומוזיקה חיה.",
        looking_for: "מחפש שלושה שותפים זורמים לטיול מאתגר ברמת קושי קשה",
        favoriteTrips: [trips[0], trips[1]],
        phone: "0508787111",
        email: "omer_cohen@gmail.com",
        status: "in-process"

    },
    {
        id: 3,
        title: "נועה כהן",
        image: "/images/Noa_Cohen.png",
        coverImage: "/images/maya-cover1.jpg",
        age: "24",
        location: "חיפה",
        interests: "יוגה, קריאה, טבע, צילומי נוף",
        favorite_trip_locations: "הכרמל, הגליל העליון",
        favorite_trip_styles: ["טיולים רגועים", "הליכות ביער", "מדיטציות בטבע", "קמפינג על הים"],
        about: "אני סטודנטית לספרות, אוהבת לטייל כדי להתחבר לעצמי ולסביבה. הטיולים שאני הכי אוהבת הם עם אווירה רגועה ובלי לחץ. שמחה להכיר שותפים שמחפשים שקט ונוף ירוק.",
        looking_for: "מחפשת שני שותפים קלילים וחברותיים לטייל איתם ברמת קושי קלה",
        favoriteTrips: [trips[0], trips[1]]
    },
    {
        id: 4,
        title: "שני יעקב",
        image: "/images/Shani_Yaakov.png",
        coverImage: "/images/maya-cover1.jpg",
        age: "25",
        location: "חיפה",
        interests: "יוגה, קריאה, טבע, צילומי נוף",
        favorite_trip_locations: "הכרמל, הגליל העליון",
        favorite_trip_styles: ["טיולים רגועים", "הליכות ביער", "מדיטציות בטבע", "קמפינג על הים"],
        about: "אני סטודנטית לספרות, אוהבת לטייל כדי להתחבר לעצמי ולסביבה. הטיולים שאני הכי אוהבת הם עם אווירה רגועה ובלי לחץ. שמחה להכיר שותפים שמחפשים שקט ונוף ירוק.",
        looking_for: "מחפשת שני שותפים קלילים וחברותיים לטייל איתם ברמת קושי קלה",
        favoriteTrips: [trips[0], trips[1]]
    },
];
